import { TableQueryType } from '../store/schema/TableQuery';
import MailFolderTableQuery from '../store/schema/MailFolderTableQuery';
import { getStore as getListViewStore } from 'owa-mail-list-store';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';

/**
 * Gets the inbox classification filter for the given table
 * @returns the inbox classification filter
 */
export default function getInboxClassificationFilterForTable(
    tableViewId: string
): InboxClassificationFilter {
    const tableView = getListViewStore().tableViews.get(tableViewId);

    switch (tableView.tableQuery.type) {
        case TableQueryType.Folder:
            return (tableView.tableQuery as MailFolderTableQuery).inboxClassificationFilter;
        case TableQueryType.Group:
        case TableQueryType.Search:
            return InboxClassificationFilter.None;
        default:
            throw new Error('Table Query should be either of type search, mail folder or group');
    }
}
